(function ($) {

    $.fn.updateAvatarInline = function (options) {

        var self = $(this);

        var settings = $.extend({
            HiddenValueSelector: "#ImageURL",
            ImageFieldSelector: "",
            FileInputFieldSelector: "",
            SuccessHandler: undefined,
            S3RefreshURL: "",
            TargetImageFieldWidth: 100,
            TargetImageFieldHeight: 100,
            ValidFileTypes: undefined
        }, options);

        self.uploadAttemptsCount = 0;

        function UploadSuccess(data, textStatus, xhr) {

            var newSrc = YouLi.Common.Utils.AddParametersToURL("https://ylt-images.imgix.net/" + encodeURIComponent(YouLi.Common.S3FileUpload.NewFileKey), "fit=crop&crop=" + settings.CropType + (settings.ModalImageFieldHeight == "auto" ? "" : "&h=" + settings.ModalImageFieldHeight) + "&w=" + settings.ModalImageFieldWidth),
            image = new Image();
            image.src = newSrc;
            image.onload = function () {
                self.find(".thumbnail-image").attr("src", newSrc);
                YouLi.Common.UI.HideAvatarLoading(settings.FileInputFieldSelector);
                YouLi.Common.UI.HideButtonLoading(".btn-form-complete");
            }
            $(settings.HiddenValueSelector).val(encodeURIComponent(YouLi.Common.S3FileUpload.NewFileKey));  // could call if needed: .trigger("change");

            self.find("#file").val(""); /* clear file selection to allow the same file to be selected again and trigger upload */

            // Nb: loading button will be cleared when new image is loaded
        }

        function UploadError(xhr, ajaxOptions, thrownError) {

            if (xhr.status == 403 && self.uploadAttemptsCount == 0) {
                // forbidden - try to refresh policy
                YouLi.Common.Get({
                    url: settings.S3RefreshURL,
                    suppressLoading: true,
                }).then(function (response) {
                    YouLi.Common.S3FileUpload.KeyPrefix = response.newKeyPrefix + response.newUUID;
                    YouLi.Common.S3FileUpload.Uuid = response.newUUID;
                    YouLi.Common.S3FileUpload.Policy = response.policy;
                    YouLi.Common.S3FileUpload.PolicySignature = response.policySignature;

                    self.uploadAttemptsCount++;
                    YouLi.Common.S3FileUpload.SingleFileSelected(self.querySelector("input[type='file']"), settings.ValidFileTypes, UploadSuccess, UploadError, UploadComplete);
                });
            }
            else {
                alert("There was an error attempting to upload the file. (" + thrownError + ")");
                self.uploadAttemptsCount++;
                self.find("#file").val(""); /* clear file selection to allow the same file to be selected again and trigger upload */
                YouLi.Common.UI.HideAvatarLoading(settings.FileInputFieldSelector);
                YouLi.Common.UI.HideButtonLoading(".btn-form-complete");
            }
        }

        function UploadComplete(data, textStatus, xhr) {
        }

        $(function () {
            YouLi.Common.UI.Init();

            self.off("change", "input[type='file']").on("change", "input[type='file']", function (e) {
                if (this.files.length >= 1) {
                    YouLi.Common.UI.ShowAvatarLoading(settings.FileInputFieldSelector);
                    YouLi.Common.UI.ShowButtonLoading(".btn-form-complete");
      
                    // Get a fresh S3 policy every time (so a user can upload the same file more than once, e.g. after changing it on their computer)
                    YouLi.Common.Get({
                        url: settings.S3RefreshURL,
                        errorCallback: function () {
                            YouLi.Common.UI.ShowStandardDialog("An error occurred. Please refresh the page to try again.");
                        }
                    }).then(function (response) {
                        YouLi.Common.S3FileUpload.KeyPrefix = response.newKeyPrefix + response.newUUID;
                        YouLi.Common.S3FileUpload.Uuid = response.newUUID;
                        YouLi.Common.S3FileUpload.Policy = response.policy;
                        YouLi.Common.S3FileUpload.PolicySignature = response.policySignature;

                        self.uploadAttemptsCount = 0;

                        if (!YouLi.Common.S3FileUpload.SingleFileSelected(e.target, settings.ValidFileTypes, UploadSuccess, UploadError, UploadComplete)) {
                            YouLi.Common.UI.HideAvatarLoading(settings.FileInputFieldSelector);
                            YouLi.Common.UI.HideButtonLoading(".btn-form-complete");
                        }

                    });
                }
            });
        });

        return this;
    };

}(jQuery));